import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, MessageSquareIcon, ShieldCheckIcon, BadgeCheckIcon, MapPinIcon } from 'lucide-react';
import { SITE } from '../constants/site';
export function Hero({
  onOpenSchedule
}: {
  onOpenSchedule?: () => void;
}) {
  return <section id="top" className="relative w-full overflow-hidden bg-nfblue-dark" data-id="element-168" data-mp="4lqictyan92g">
      <div className="absolute inset-0" data-id="element-169" data-mp="4jm5vnmbx1qk">
        <img src={SITE.heroImageUrl} alt="Aerial view of a lush North Texas lawn with an irrigation system running at sunset" className="h-full w-full object-cover" data-id="element-170" data-mp="12a0l5b5wm0um" />
        <div className="absolute inset-0 bg-gradient-to-r from-nfblue-dark/95 via-nfblue-dark/80 to-nfblue-dark/40" data-id="element-171" data-mp="x8jnrpmmowis" />
        <div className="absolute inset-0 bg-gradient-to-t from-nfblue-dark/90 via-transparent to-transparent" data-id="element-172" data-mp="ncgkggg1iru9" />
      </div>

      <div className="relative mx-auto grid max-w-7xl gap-8 px-4 py-16 sm:px-6 lg:grid-cols-12 lg:py-28 lg:px-8" data-id="element-173" data-mp="3d1sa6w93nhsl">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="lg:col-span-8" data-id="element-174" data-mp="381nvnbrr4x50">
          <div className="flex flex-wrap items-center gap-3" data-id="element-175" data-mp="3o6arg04e8f22">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-white backdrop-blur" data-id="element-176" data-mp="39auqdb5ebiw6">
              <MapPinIcon className="h-3.5 w-3.5" data-id="element-177" data-mp="30iaziwvciilw" />
              Serving Garland, TX & All of North Texas
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-nfgreen/50 bg-nfgreen/20 px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-nfgreen-light backdrop-blur" data-id="element-178" data-mp="358zoo5jjz3hv">
              <span className="relative flex h-2 w-2" data-id="element-179" data-mp="2vjzq2n8yqa47">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-nfgreen opacity-75" data-id="element-180" data-mp="2vglkl6505ksj"></span>
                <span className="relative inline-flex h-2 w-2 rounded-full bg-nfgreen" data-id="element-181" data-mp="2lla70r5byjmd"></span>
              </span>
              24/7 & Same-Day Service
            </span>
          </div>

          <h1 className="mt-6 font-display text-4xl font-extrabold leading-tight text-white sm:text-5xl lg:text-6xl" data-id="element-182" data-mp="nbba6qtxtx1l">
            The Hidden Water Leak Costing Texas Homeowners{' '}
            <span className="text-nfgreen-light" data-id="element-183" data-mp="i9vqp37erylb">$80–$200 Extra</span> Every Month
          </h1>

          <p className="mt-5 max-w-2xl text-lg text-slate-200 sm:text-xl" data-id="element-184" data-mp="dbapb0gf78va">
            And the licensed fix that makes your lawn the best-looking one on the
            block. Most irrigation "repairs" are guesses by unlicensed workers using
            cheap parts. We diagnose what others can't see — and fix it permanently.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-185" data-mp="x1w6u8q1wrhv">
            <a href={SITE.phoneHref} className="inline-flex items-center justify-center gap-2 rounded-full bg-nfgreen px-7 py-4 text-base font-bold text-white shadow-lg shadow-nfgreen/30 transition-transform hover:scale-[1.03] hover:bg-nfgreen-dark" data-id="element-186" data-mp="3lsp49g06snfh">
              <PhoneIcon className="h-5 w-5" data-id="element-187" data-mp="1xb5q6f7x0tgn" />
              Call Now: {SITE.phone}
            </a>
            <a href={SITE.smsHref} className="inline-flex items-center justify-center gap-2 rounded-full border border-white/30 bg-white/10 px-7 py-4 text-base font-bold text-white backdrop-blur transition-colors hover:bg-white/20" data-id="element-188" data-mp="21b63fwja2ym4">
              <MessageSquareIcon className="h-5 w-5" data-id="element-189" data-mp="2fzssipypj4qj" />
              Text Us
            </a>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm font-semibold text-white" data-id="element-190" data-mp="2kynbpt0l6vb6">
            <span className="flex items-center gap-2" data-id="element-191" data-mp="2ozz5maqhu2p6">
              <BadgeCheckIcon className="h-5 w-5 text-nfgreen-light" data-id="element-192" data-mp="2oye7yc8vu3n3" />
              License {SITE.license}
            </span>
            <span className="flex items-center gap-2" data-id="element-193" data-mp="umppw17ctkyh">
              <ShieldCheckIcon className="h-5 w-5 text-nfgreen-light" data-id="element-194" data-mp="uo0ug38miwqn" />
              Fully Insured
            </span>
            <span className="flex items-center gap-2" data-id="element-195" data-mp="znn8ug06uj11">
              <BadgeCheckIcon className="h-5 w-5 text-nfgreen-light" data-id="element-196" data-mp="4acmjdl07r7y" />
              Residential & Commercial
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="lg:col-span-4 lg:flex lg:items-end" data-id="element-197" data-mp="e9k1u6batvxp">
          <div className="w-full rounded-2xl border border-white/15 bg-white/95 p-6 shadow-2xl backdrop-blur" data-id="element-198" data-mp="3hr2663rv4ktd">
            <p className="font-display text-lg font-bold text-slate-900" data-id="element-199" data-mp="3csqxhwdb0gcq">
              Professional System Diagnostic
            </p>
            <p className="mt-1 text-sm text-slate-600" data-id="element-200" data-mp="3mpdfmde8wtb2">
              We walk your property, find every hidden issue, and give you a clear, honest
              assessment of what it takes to fix it right.
            </p>
            <ul className="mt-4 space-y-2 text-sm text-slate-700" data-id="element-201" data-mp="2u17tpnbggy9n">
              {['Water pressure diagnostics', 'Zone mapping & coverage', 'Leak detection', 'Code-compliant repairs'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-202" data-mp="1e9dp5i5iozvw">
                  <BadgeCheckIcon className="h-4 w-4 shrink-0 text-nfgreen" data-id="element-203" data-mp="1eaotbj2vk9nj" />
                  {item}
                </li>)}
            </ul>
            <button onClick={onOpenSchedule} className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-full bg-nfblue px-5 py-3 text-sm font-bold text-white transition-colors hover:bg-nfblue-dark" data-id="element-204" data-mp="14jawjj2b5ny3">
              Schedule a Diagnostic
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}